module.exports = __webpack_public_path__ + "img/icon-qrcode.8d3718fd.svg";